import { Box, Button, Chip, Divider, Paper, Typography } from '@mui/material'
import React, { useMemo } from 'react'
import { useNavigate } from 'react-router-dom'
import { CTAMap } from '../ctaData'
// import { Link } from "react-router-dom";

const CardContainer = ({ item: bookingData }) => {
    const navigate = useNavigate()
    const HandleViewBookings = (bookingId) => {
        navigate(`/bookings/${bookingId}`)
    }
    const allowedTabs = useMemo(() => {
        return CTAMap[bookingData?.status?.enumValue]?.tabs
    }, [bookingData])
    const totalPeopleRequired = useMemo(
        () => Object.values(bookingData?.peopleRequired).reduce((prev, next) => Number(prev) + Number(next)),
        [bookingData]
    )
    return (
        <Paper
            variant="outlined"
            style={{
                padding: '16px',
                flex: 1,
                overflowX: 'hidden',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
            }}
        >
            <Box>
                <Box display="flex" justifyContent="space-between">
                    <Typography variant="h6" fontWeight={600}>
                        {bookingData?.jobType}
                    </Typography>
                    <Chip
                        sx={(theme) => ({
                            backgroundColor: theme.palette.grey[200],
                            height: '24px',
                        })}
                        label={bookingData?.status?.enumLabel}
                    />
                </Box>
                <Box display="flex" justifyContent="space-between">
                    <Typography sx={(theme) => ({ color: theme.palette.grey[700] })} variant="caption">
                        ID : {bookingData?.bookingId}
                    </Typography>
                    <Typography sx={(theme) => ({ color: theme.palette.grey[700] })} variant="caption">
                        {bookingData?.createdOn}
                    </Typography>
                </Box>
            </Box>
            {allowedTabs && (
                <>
                    <Box mt={2} mb={2} display="flex">
                        {Object.keys(allowedTabs)?.map((item) => {
                            const [state] = bookingData?.jobCardsStateCount?.filter((obj) => obj.enumValue === item)
                            return (
                                <Paper
                                    key={item}
                                    sx={(theme) => ({
                                        backgroundColor: theme.palette.grey[100],
                                        mr: 2,
                                        p: 2,
                                        cursor: 'pointer',
                                    })}
                                >
                                    <Typography variant="h5" align="center">
                                        {state?.count}
                                        {item === 'DEPLOYMENT_COMPLETE' && <>/{totalPeopleRequired}</>}
                                    </Typography>

                                    <Typography
                                        sx={(theme) => ({
                                            color: theme.palette.grey[700],
                                        })}
                                        align="center"
                                    >
                                        {state?.enumLabel}
                                    </Typography>
                                </Paper>
                            )
                        })}
                    </Box>
                </>
            )}

            <Box mt={2} mb={2} flex={1} display="flex" justifyContent="space-between">
                <Paper
                    elevation={0}
                    sx={(theme) => ({
                        width: '50%',
                        py: 2,
                        cursor: 'pointer',
                        border: 'none',
                        fontSize: '10px',
                    })}
                >
                    <Typography variant="h6" align="left" fontSize={16} fontWeight={400}>
                        Supervisor: {bookingData?.peopleRequired?.SUPERVISOR}
                    </Typography>
                    <Typography variant="h6" align="left" fontSize={16} fontWeight={400}>
                        Helper: {bookingData?.peopleRequired?.HELPER}
                    </Typography>
                    <Typography variant="h6" align="left" fontSize={16} fontWeight={400}>
                        Technician: {bookingData?.peopleRequired?.TECHNICIAN}
                    </Typography>
                </Paper>
                <Paper
                    elevation={0}
                    sx={(theme) => ({
                        width: '50%',
                        py: 2,
                        cursor: 'pointer',
                        border: 'none',
                    })}
                >
                    <Typography variant="h6" align="left" fontSize={16} fontWeight={400}>
                        Company: {bookingData?.cmpName}
                    </Typography>
                    <Typography variant="h6" align="left" fontSize={16} fontWeight={400}>
                        Site Address: {bookingData?.siteAddress}
                    </Typography>
                    <Typography variant="h6" align="left" fontSize={16} fontWeight={400}>
                        Location: {bookingData?.city}, {bookingData?.state}
                    </Typography>
                </Paper>
            </Box>
            <Divider />
            <Box mt={2} display="flex" justifyContent="flex-end">
                <Button
                    onClick={() => {
                        HandleViewBookings(bookingData?.bookingId)
                    }}
                >
                    View Bookings
                </Button>
            </Box>
        </Paper>
    )
}

export default CardContainer
